import { AdaptableModuleBase } from './AdaptableModuleBase';
import * as ModuleConstants from '../Utilities/Constants/ModuleConstants';
export class StateManagementModule extends AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.StateManagementModuleId, ModuleConstants.StateManagementFriendlyName, 'assignment', 'StateManagementPopup', 'Manages Adaptable State, User State and Predefined Config', api);
    }
}
